import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"
import ProductCarousel from "./ProductCarousel";
import SmallProductCarousel from "./SmallProductCarousel";
import ProductAll from "./ProductAll";
import ProductList from "./ProductList";
import { useStoreProduct } from "contexts/store_product";
const ImageBlock = ({ data }) => {

    return (

        <Image src={data.setting.image?.lg_url} style={{width:"100%", height:"auto"}} ></Image>

    )

}

export default memo(ImageBlock)